import { useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollWindowToTop } from '../utils/runViewTransition'

/** SPA navigations keep document scroll; reset on pathname change only. */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
  }, [])

  useLayoutEffect(() => {
    scrollWindowToTop()
  }, [pathname])

  return null
}
